__turbopack_context__.v({
  "accordionSlideOverwrite": "productFeatureTabs-module-scss-module__bOGvyq__accordionSlideOverwrite",
  "content": "productFeatureTabs-module-scss-module__bOGvyq__content",
  "description": "productFeatureTabs-module-scss-module__bOGvyq__description",
  "fadeIn": "productFeatureTabs-module-scss-module__bOGvyq__fadeIn",
  "fadeOut": "productFeatureTabs-module-scss-module__bOGvyq__fadeOut",
  "header": "productFeatureTabs-module-scss-module__bOGvyq__header",
  "image": "productFeatureTabs-module-scss-module__bOGvyq__image",
  "imageContainer": "productFeatureTabs-module-scss-module__bOGvyq__imageContainer",
  "productFeatureTabs": "productFeatureTabs-module-scss-module__bOGvyq__productFeatureTabs",
  "scaleIn": "productFeatureTabs-module-scss-module__bOGvyq__scaleIn",
  "scaleOut": "productFeatureTabs-module-scss-module__bOGvyq__scaleOut",
  "tabContent": "productFeatureTabs-module-scss-module__bOGvyq__tabContent",
  "title": "productFeatureTabs-module-scss-module__bOGvyq__title",
  "zoomIn": "productFeatureTabs-module-scss-module__bOGvyq__zoomIn",
  "zoomOut": "productFeatureTabs-module-scss-module__bOGvyq__zoomOut",
});
